export default "__VITE_ASSET__MsoxucS5__"